<script>
    import {onDestroy} from 'svelte';
    import StatementScaleInput from 'views/components/taskGroups/tasks/template42/StatementScaleInput.svelte';

    const {
        model,
        response,
        syncResponse,
    } = $props()

    // svelte-ignore state_referenced_locally
    const scale = $state(model.get('task_info_json').scale)

    let isAnswerLocked = $state(false)

    // svelte-ignore state_referenced_locally
    let givenResponse = $state(
        response.get('json_answer')?.[0]
    )

    function saveResponse(newResponse) {
        givenResponse = newResponse
        syncResponse([newResponse])
    }

    export function showAnswer() {
        saveResponse(givenResponse)
        isAnswerLocked = true
    }

    export function showAuthorAnswer() {
        isAnswerLocked = true
    }

    export function hideAnswer() {
        isAnswerLocked = false
    }

    export function lockAnswer() {
        isAnswerLocked = true
    }
    export function unlockAnswer() {
        isAnswerLocked = false
    }

    onDestroy(() => {
        saveResponse(givenResponse)
    })
</script>

<StatementScaleInput
    {scale}
    bind:value={() => givenResponse, saveResponse}
    disabled={isAnswerLocked}
></StatementScaleInput>
